import { render, staticRenderFns } from "./BuyBoxBanner.vue?vue&type=template&id=376a195c&scoped=true"
import script from "./BuyBoxBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyBoxBanner.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BuyBoxBanner.vue?vue&type=style&index=0&id=376a195c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a195c",
  null
  
)

export default component.exports